package kotlinx.css

class TagSelector(val tagName: String)

val a get() = TagSelector("a")
val abbr get() = TagSelector("abbr")
val area get() = TagSelector("area")
val address get() = TagSelector("address")
val article get() = TagSelector("article")
val aside get() = TagSelector("aside")
val audio get() = TagSelector("audio")

val b get() = TagSelector("b")
val bdi get() = TagSelector("bdi")
val blockquote get() = TagSelector("blockquote")
val bdo get() = TagSelector("bdo")
val body get() = TagSelector("body")
val br get() = TagSelector("br")
val button get() = TagSelector("button")

val canvas get() = TagSelector("canvas")
val cite get() = TagSelector("cite")
val code get() = TagSelector("code")
val command get() = TagSelector("command")

val datalist get() = TagSelector("datalist")
val del get() = TagSelector("del")
val details get() = TagSelector("details")
val dfn get() = TagSelector("dfn")
val dialog get() = TagSelector("dialog")
val div get() = TagSelector("div")
val dl get() = TagSelector("dl")

val em get() = TagSelector("em")
val embed get() = TagSelector("embed")

val fieldset get() = TagSelector("fieldset")
val figure get() = TagSelector("figure")
val figcaption get() = TagSelector("figcaption")
val footer get() = TagSelector("footer")
val form get() = TagSelector("form")

val h1 get() = TagSelector("h1")
val h2 get() = TagSelector("h2")
val h3 get() = TagSelector("h3")
val h4 get() = TagSelector("h4")
val h5 get() = TagSelector("h5")
val h6 get() = TagSelector("h6")
val header get() = TagSelector("header")
val hgroup get() = TagSelector("hgroup")
val hr get() = TagSelector("hr")
val html get() = TagSelector("html")

val i get() = TagSelector("i")
val iframe get() = TagSelector("iframe")
val img get() = TagSelector("img")
val input get() = TagSelector("input")
val ins get() = TagSelector("ins")

val kbd get() = TagSelector("kbd")
val keygen get() = TagSelector("keygen")

val label get() = TagSelector("label")
val link get() = TagSelector("link")

val map get() = TagSelector("map")
val mark get() = TagSelector("mark")
val math get() = TagSelector("math")
val menu get() = TagSelector("menu")
val meta get() = TagSelector("meta")
val meter get() = TagSelector("meter")

val nav get() = TagSelector("nav")
val noscript get() = TagSelector("noscript")

val ol get() = TagSelector("ol")
val objectTag get() = TagSelector("object")
val output get() = TagSelector("output")

val p get() = TagSelector("p")
val pre get() = TagSelector("pre")
val progress get() = TagSelector("progress")

val q get() = TagSelector("q")

val ruby get() = TagSelector("ruby")

val samp get() = TagSelector("samp")
val script get() = TagSelector("script")
val section get() = TagSelector("section")
val select get() = TagSelector("select")
val small get() = TagSelector("small")
val span get() = TagSelector("span")
val strong get() = TagSelector("strong")
val style get() = TagSelector("style")
val sub get() = TagSelector("sub")
val sup get() = TagSelector("sup")
val svg get() = TagSelector("svg")

val table get() = TagSelector("table")
val textarea get() = TagSelector("textarea")
val time get() = TagSelector("time")

val ul get() = TagSelector("ul")

val varTag get() = TagSelector("var")
val video get() = TagSelector("video")
